import { ActionIcon, Tooltip } from '@mantine/core';
import type { ReactNode } from 'react';
import { LuArrowLeft, LuSave } from 'react-icons/lu';
import {
  StyledEditorHeader,
  StyledEditorHeaderActions,
  StyledEditorHeaderRow,
  StyledEditorHeaderSide,
} from './styles';

type EditorHeaderProps = {
  actionLabel: string;
  actionDisabled?: boolean;
  formId?: string;
  isPending: boolean;
  onAction?: () => void;
  onBack: () => void;
  rightSlot?: ReactNode;
};

export const EditorHeader = ({
  actionLabel,
  actionDisabled = false,
  formId,
  isPending,
  onAction,
  onBack,
  rightSlot,
}: EditorHeaderProps) => {
  return (
    <StyledEditorHeader>
      <StyledEditorHeaderRow>
        <StyledEditorHeaderSide>
          <Tooltip label="Back" position="bottom">
            <ActionIcon
              variant="default"
              color="gray"
              size="lg"
              onClick={onBack}
            >
              <LuArrowLeft size={18} />
            </ActionIcon>
          </Tooltip>
        </StyledEditorHeaderSide>

        <StyledEditorHeaderActions>
          {rightSlot}
          <Tooltip label={actionLabel} position="bottom">
            <ActionIcon
              color="cyan"
              disabled={actionDisabled}
              form={formId}
              loading={isPending && !actionDisabled}
              onClick={formId ? undefined : onAction}
              size="lg"
              type={formId ? 'submit' : 'button'}
              variant="filled"
            >
              <LuSave size={18} />
            </ActionIcon>
          </Tooltip>
        </StyledEditorHeaderActions>
      </StyledEditorHeaderRow>
    </StyledEditorHeader>
  );
};
